<template>
  <div :class="['ihu-toggle', { 'disabled': disabled }]">
    <div :class="['toggle-frame', toggleFrameStateClass]"
         :aria-labelledby="ariaLabelledBy"
         :disabled="disabled"
         :aria-pressed="isToggled"
         role="button"
         tabindex="0"
         @keydown.enter.space.prevent="onToggleClick"
         @click="onToggleClick">
      <div class="toggle-button"></div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'ihu-toggle',
    model: {
      prop: 'state',
      event: 'change',
    },
    props: {
      state: {
        type: Boolean,
        required: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      ariaLabelledBy: {
        type: String,
        default: '',
      },
    },
    computed: {
      toggleFrameStateClass() {
        return this.state ? 'toggle-active' : 'toggle-inactive';
      },
      isToggled() {
        return this.state ? 'true' : 'false';
      },
    },
    methods: {
      onToggleClick() {
        this.$emit('change', !this.state);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .ihu-toggle {
    .toggle-frame {
      display: inline-block;
      position: relative;
      cursor: pointer;
      height: 16px;
      width: 28px;
      border-radius: 16px;
      background-color: #175AFC;

      .toggle-button {
        width: 14px;
        height: 14px;
        position: absolute;
        border-radius: 50%;
        margin-top: 1px;
        box-shadow: 1px 1px 0px rgba(0, 0, 0, 0.14);
        background: #F8F8FF;
      }

      &.toggle-active {
        .toggle-button {
          right: 2px;
        }
      }
      &.toggle-inactive {
        .toggle-button {
          right: calc(100% - 16px);
        }
      }
    }

    &.disabled {
      cursor: default;
      pointer-events: none;
      opacity: .5;
    }
  }
</style>
